export const templates = { "C:/apps/wpc-portal/wpc_portal/static/src/pages/layout.xml": `<?xml version="1.0" encoding="UTF-8"?>
<templates xml:space="preserve">
    <t t-name="wpc_portal.wpc_portal_root_layout" owl="1">
        <nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm py-3 wpc-navbar">
            <div class="container-fluid">
                <div class="navbar-brand d-flex align-items-center">
                    <img src="/static/img/logo.png" class="me-2" style="max-width: 44px;"/>
                    <strong class="d-none d-md-block" style="font-size: 1.1rem; color: var(--wpc-dark);">
                        Work Placement Connect
                    </strong>
                </div>

                <button class="navbar-toggler border-0" type="button"
                        data-bs-toggle="collapse" data-bs-target="#mainNav">
                    <span class="navbar-toggler-icon"/>
                </button>

                <div class="collapse navbar-collapse" id="mainNav">
                    <ul class="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center gap-lg-1">
                        <li class="nav-item">
                            <a t-attf-class="nav-link px-3 {{ state.hash === '' &amp;&amp; 'active' }}" href="/#">Home</a>
                        </li>
                        <li class="nav-item">
                            <a t-attf-class="nav-link px-3 {{ state.hash === 'teachers' &amp;&amp; 'active' }}" href="/#teachers">Teachers</a>
                        </li>
                        <li class="nav-item">
                            <a t-attf-class="nav-link px-3 {{ state.hash === 'students' &amp;&amp; 'active' }}" href="/#students">Students</a>
                        </li>
                        <li class="nav-item">
                            <a t-attf-class="nav-link px-3 {{ state.hash === 'employers' &amp;&amp; 'active' }}" href="/#employers">Employers</a>
                        </li>
                        <li class="nav-item">
                            <a t-attf-class="nav-link px-3 {{ state.hash === 'resources' &amp;&amp; 'active' }}" href="/#resources">Resources</a>
                        </li>
                        <li class="nav-item">
                            <a t-attf-class="nav-link px-3 {{ state.hash === 'contact' &amp;&amp; 'active' }}" href="/#contact">Contact Us</a>
                        </li>
                        <li class="nav-item ms-lg-2">
                            <div class="d-flex align-items-start">
                                <WPCPortalAccountStatus t-if="env.wpc_state.auth.role" currentPage="currentPage"/>
                                <a t-else="" href="/portal"
                                   class="btn login-btn">
                                    Login / Register
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>

            </div>
        </nav>
        <t t-raw="0"/>
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/pages/layout_industry_block.xml": `<?xml version="1.0" encoding="UTF-8"?>
<templates xml:space="preserve">
    <t t-name="wpc_portal.wpc_portal_root_industry_block_layout" owl="1">
        <div class="col-lg-5 industry-section p-4 p-lg-5">
            <p class="section-eyebrow mb-4">Industry Areas</p>
            <div class="row row-cols-3 g-4 text-center">

                <div class="col">
                    <div class="industry-circle">
                        <i class="bi bi-egg-fried"/>
                    </div>
                    <p class="industry-label">Hospitality</p>
                </div>

                <div class="col">
                    <div class="industry-circle">
                        <i class="bi bi-heart-pulse"/>
                    </div>
                    <p class="industry-label">Human Services</p>
                </div>

                <div class="col">
                    <div class="industry-circle">
                        <i class="bi bi-laptop"/>
                    </div>
                    <p class="industry-label">Information &amp; Technology</p>
                </div>

                <div class="col">
                    <div class="industry-circle">
                        <i class="bi bi-gear-wide-connected"/>
                    </div>
                    <p class="industry-label">Manufacturing &amp; Engineering</p>
                </div>

                <div class="col">
                    <div class="industry-circle">
                        <i class="bi bi-tree"/>
                    </div>
                    <p class="industry-label">Primary Industries</p>
                </div>

                <div class="col">
                    <div class="industry-circle">
                        <i class="bi bi-bag"/>
                    </div>
                    <p class="industry-label">Retail Services</p>
                </div>

                <div class="col">
                    <div class="industry-circle">
                        <i class="bi bi-car-front"/>
                    </div>
                    <p class="industry-label">Automotive</p>
                </div>

                <div class="col">
                    <div class="industry-circle">
                        <i class="bi bi-briefcase"/>
                    </div>
                    <p class="industry-label">Business Services</p>
                </div>

                <div class="col">
                    <div class="industry-circle">
                        <i class="bi bi-hammer"/>
                    </div>
                    <p class="industry-label">Construction</p>
                </div>

                <div class="col">
                    <div class="industry-circle">
                        <i class="bi bi-plug"/>
                    </div>
                    <p class="industry-label">Electrotechnology</p>
                </div>

                <div class="col">
                    <div class="industry-circle">
                        <i class="bi bi-music-note-beamed"/>
                    </div>
                    <p class="industry-label">Entertainment Industry</p>
                </div>

                <div class="col">
                    <div class="industry-circle">
                        <i class="bi bi-calculator"/>
                    </div>
                    <p class="industry-label">Financial Services</p>
                </div>

            </div>
        </div>
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/components/account_status/account_status.xml": `<templates>
    <t t-name="wpc_portal.account_status">
        <div class="dropdown">
          <div class="d-inline-flex align-items-center px-md-3 px-0 py-2" data-bs-toggle="dropdown" aria-expanded="false" style="cursor: pointer;">
            <div class="rounded-circle d-flex align-items-center justify-content-center overflow-hidden" style="width:40px;height:40px;background-color:#ff914d24;">
                <i class="bi bi-person-fill fs-4 text-wpc"/>
            </div>
            <div class="ms-3">
              <div class="d-flex align-items-center">
                <span class="fw-semibold flex-grow-1"><t t-esc="env.wpc_state.auth.user_displayname"/></span>
                <i class="bi bi-chevron-down ms-1 text-muted"/>
              </div>
                <div class="text-truncate text-muted" style="font-size: smaller;max-width: 150px;">
                    <span t-esc="env.wpc_state.auth.username"/>
                </div>
            </div>
          </div>
        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
            <li t-if="props.currentPage == 'home'">
                <a class="dropdown-item" style="cursor: pointer;" href="/portal">Portal</a>
            </li>
            <li t-elif="props.currentPage == 'portal'">
                <a class="dropdown-item" style="cursor: pointer;" href="/">Home</a>
            </li>
            <li>
                <a class="dropdown-item" style="cursor: pointer;" t-on-click="this.doLogout" >Log Out</a>
            </li>
          </ul>
        </div>
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/components/login/login.xml": `<templates>
    <t t-name="wpc_portal.login">
        <div class="login-container">
            <div class="d-flex role-type-menu">
                <div class="item active pointer">
                    Student Portal
                </div>
                <a class="item text-muted" href="https://wpc-admin.schoolsindustry.com.au/">
                    Teacher Portal
                </a>
                <button t-if="props.show_close" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
            </div>
            <div class="mt-4 mb-4">
                <h4 class="text-center mb-0" style="font-weight: 700;">
                    <t t-if="state.cred_type == 'login'">
                        Login to Work Place Connect
                    </t>
                    <t t-elif="state.cred_type == 'create'">
                        Create your student account
                    </t>
                    <t t-elif="state.cred_type == 'forgot'">
                        Forgot Password
                    </t>
                    <t t-elif="state.cred_type == 'change_password'">
                        Change Password
                    </t>
                    <t t-else="">
                        Instructions Sent
                    </t>
                </h4>
            </div>
            <div class="r" t-if="props.auth.step === 'cred'">
                <div class="login-form">
                    <t t-if="state.cred_type == 'login'">
                        <form t-on-submit.prevent="doLogin" class="form">
                            <div class="form-group">
                                <label for="exampleInputEmail1">Student Email address</label>
                                <input tabindex="1" type="email" t-model="this.state.email" class="form-control" id="txtEmail" aria-describedby="emailHelp"/>
            <!--                    <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>-->
                            </div>
                            <div class="form-group">
                                <div class="d-flex justify-content-between">
                                    <label for="exampleInputPassword1">Password</label>
                                    <a class="btn-link" href="#" t-on-click="()=>{this.state.cred_type = 'forgot'; this.state.lastErrorMessage = '';}">Forgot?</a>
                                </div>
                                <input tabindex="2" type="password" t-model="this.state.password" class="form-control" id="txtPassword"/>
                            </div>
                            <div class="text-danger" t-out="this.state.lastErrorMessage" t-if="this.state.lastErrorMessage"/>
                            <div t-if="!this.state.lastErrorMessage"/>
                            <div class="d-flex flex-column">
                                <button tabindex="3" type="submit" class="btn btn-primary mt-2">Login</button>
                                <p class="text-muted text-center mt-2">
                                    Don't have an account? <a class="btn-link" tabindex="4" t-on-click="()=>{this.state.cred_type = 'create'}">Create an account</a>
                                </p>
                            </div>
                        </form>
                    </t>
                    <t t-elif="state.cred_type == 'change_password'">
                        <form t-on-submit.prevent="doChangePassword" class="form">
                            <div class="form-group">
                                <label for="exampleInputEmail1">Student Email address</label>
                                <input disabled="disabled" tabindex="1" type="email" t-model="this.state.email" class="form-control" id="txtEmail" aria-describedby="emailHelp"/>
            <!--                    <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>-->
                            </div>
                            <div class="form-group">
                                <label for="exampleInputPassword1">Password</label>
                                <input tabindex="2" type="password" t-model="this.state.password" class="form-control" id="txtPassword"/>
                            </div>
                            <div class="form-group">
                                <label for="exampleInputPassword2">Confirm Password</label>
                                <input tabindex="2" type="password" t-model="this.state.password2" class="form-control" id="txtPassword2"/>
                            </div>
                            <div class="text-danger" t-out="this.state.lastErrorMessage" t-if="this.state.lastErrorMessage"/>
                            <div t-if="!this.state.lastErrorMessage"/>
                            <div class="d-flex flex-column">
                                <button tabindex="3" type="submit" class="btn btn-primary mt-2">Change Password</button>
                                <p class="text-muted text-center mt-2">
                                    Remember your login? <a class="btn-link" tabindex="4" t-on-click="()=>{ window.location.hash = ''; this.state.cred_type = 'login'}">Log in</a>
                                </p>
                            </div>
                        </form>
                    </t>
                    <t t-elif="state.cred_type == 'create'">
                        <form t-on-submit.prevent="onSubmitSignup" class="form">
                            <div class="form-group">
                                <label for="signupEmail">Student Email address</label>
                                <input tabindex="1" name="signupEmail" t-model="state.email" type="email" class="form-control" id="signupEmail" placeholder="name@example.com" required="required"/>
                            </div>
                            <div class="form-group">
                                <label for="signupPassword">Password</label>
                                <input tabindex="2" name="signupPassword" t-model="state.signupPassword" type="password" class="form-control" id="signupPassword" placeholder="Password" required="required"/>
                            </div>
                            <div class="form-group">
                                <label for="floatingPassword">Confirm Password</label>
                                <input tabindex="3" t-model="state.signupPasswordConfirm" type="password" class="form-control" id="txtPasswordConfirm" placeholder="Confirm Password" required="required"/>
                            </div>
                            <div class="text-danger" t-out="this.state.lastSignupErrorMessage" t-if="this.state.lastSignupErrorMessage"/>
                            <div class="d-flex flex-column">
                                <button tabindex="4" type="submit" name="btnSubmitSignup" class="btn btn-primary" t-att-disabled="state.saving">Create Account</button>
                                <p class="text-muted text-center mt-2">
                                    Already have an account? <a class="btn-link" tabindex="5" t-on-click="()=>{this.state.cred_type = 'login'}">Log in</a>
                                </p>
                            </div>
                        </form>
                    </t>
                    <t t-elif="state.cred_type == 'forgot'">
                        <form t-on-submit.prevent="onForgotPassword" class="form">
                             <div class="form-group">
                                <label for="forgotEmail">Student Email address</label>
                                <input tabindex="1" name="forgotEmail" t-model="state.email" type="email" class="form-control" id="forgotEmail" placeholder="name@example.com" required="required"/>
                            </div>
                            <div class="text-danger" t-out="this.state.lastErrorMessage" t-if="this.state.lastErrorMessage"/>
                            <div class="d-flex flex-column">
                                <button tabindex="4" type="submit" name="btnSubmitSignup" class="btn btn-primary" t-att-disabled="state.saving">Send Instructions</button>
                                <p class="text-muted text-center mt-2">
                                    Remember your login? <a class="btn-link" tabindex="5" t-on-click="()=>{this.state.cred_type = 'login'}">Log in</a>
                                </p>
                            </div>
                        </form>
                    </t>
                    <t t-elif="state.cred_type == 'forgot_success'">
                        <form t-on-submit.prevent="onForgotPassword" class="form">
                             <h5 class="text-center" >
                                <i class="bi bi-check-circle text-wpc text-center" style="font-size:52px;"/><br/>
                             </h5>
                            <div class="d-flex flex-column">
                                <p class="text-muted text-center mt-2">
                                    Remember your login? <a class="btn-link" tabindex="5" t-on-click="()=>{this.state.cred_type = 'login'}">Log in</a>
                                </p>
                            </div>
                        </form>
                    </t>
        <!--                <pre class="mt-4">-->
        <!--ianpalmer60+test1@gmail.com-->
        <!--Sevim Test: sevsah234+teststu@gmail.com-->
        <!--Chris: chris+student@inspiredsoftware.com.au-->
        <!--Ian: ianpalmer60+25@gmail.com-->
        <!--                </pre>-->
                </div>
            </div>
            <div class="row" t-if="props.auth.step === 'role'">
                <ul t-foreach="state.roles" t-as="role" t-key="role.uid">
                    <li t-on-click="()=>{this.selectRole(role)}"><t t-esc="role.user_displayname"/> (<t t-esc="role.role"/>)</li>
                </ul>
            </div>
            <div class="row" t-if="props.auth.step === 'verify'">
                <form t-on-submit.prevent="onVerifyEmail" class="form">
                    <div class="form-group">
                        <div class="d-flex justify-content-between">
                            <label for="verifyEmail">Student Email address</label>
                            <a class="btn-link" href="#" t-on-click="()=>{this.doLogout()}">Not you? Logout</a>
                        </div>
                        <input tabindex="1" name="verifyEmail" t-model="props.auth.username" type="email" class="form-control" id="verifyEmail" disabled="disabled" readonly="readonly" placeholder="name@example.com" required="required"/>
                    </div>
                    <div class="form-group">
                        <label for="verifyEmailCode">Email Verification Code</label>
                        <input tabindex="1" name="verifyEmailCode" t-model="state.email_code" type="text" class="form-control" id="verifyEmailCode" placeholder="Verification Code" required="required"/>
                    </div>
                    <div class="text-danger" t-out="state.lastErrorMessage" t-if="this.state.lastErrorMessage"/>
                    <div class="d-flex flex-column">
                        <button tabindex="4" type="submit" name="btnSubmitSignup" class="btn btn-primary" t-att-disabled="state.saving">
                            Verify Email
                        </button>
                        <div class="alert alert-info mt-2">
                            Please enter the code in your verification email to continue.
                        </div>
                        <p class="text-muted text-center mt-2">
                             <a class="btn-link" tabindex="5" t-on-click="onSendEmailCode.bind(this)">
                                 Re-send verification code
                             </a>
                        </p>
                    </div>
                </form>
            </div>

<!--            <div class="modal fade" id="modalSignup" tabindex="-1" aria-labelledby="modalAddExternalClass" aria-hidden="true">-->
<!--                <div class="modal-dialog">-->
<!--                    <div class="modal-content">-->
<!--                        <form t-on-submit.prevent="onSubmitSignup" class="form">-->
<!--                            <div class="modal-header">-->
<!--                                <h1 class="modal-title fs-5" id="modalAddExternalClassLabel">Create your student account</h1>-->
<!--                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"/>-->
<!--                            </div>-->
<!--                            <div class="modal-body">-->
<!--                                <div style="min-height: 400px;">-->
<!--                                    <div class="form-floating">-->
<!--                                        <input name="signupEmail" t-model="state.email" type="email" class="form-control" id="signupEmail" placeholder="name@example.com" required="required"/>-->
<!--                                        <label for="signupEmail">Email address</label>-->
<!--                                    </div>-->
<!--                                    <div class="form-floating mt-2">-->
<!--                                        <input name="signupPassword" t-model="state.signupPassword" type="password" class="form-control" id="signupPassword" placeholder="Password" required="required"/>-->
<!--                                        <label for="signupPassword">Password</label>-->
<!--                                    </div>-->
<!--                                    <div class="form-floating mt-2">-->
<!--                                        <input t-model="state.signupPasswordConfirm" type="password" class="form-control" id="txtPasswordConfirm" placeholder="Confirm Password" required="required"/>-->
<!--                                        <label for="floatingPassword">Confirm Password</label>-->
<!--                                    </div>-->
<!--                                    <div class="text-danger" t-out="this.state.lastSignupErrorMessage" t-if="this.state.lastSignupErrorMessage"/>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="modal-footer">-->
<!--                                <button type="button" class="btn" data-bs-dismiss="modal">Close</button>-->
<!--                                <button type="submit" name="btnSubmitSignup" class="btn btn-primary" t-att-disabled="state.saving">Create Account</button>-->
<!--                            </div>-->
<!--                        </form>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
        </div>

<!--        <p>-->
<!--            <strong>Login State</strong><br />-->
<!--            <pre t-esc="window.JSON.stringify(state, null, 4)"/>-->
<!--            <pre t-esc="window.JSON.stringify(env.wpc_state.auth, null, 4)"/>-->
<!--            <pre t-esc="window.JSON.stringify(props.auth, null, 4)"/>-->
<!--        </p>-->
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/components/student_class_list/student_class_list.xml": `<templates>
    <t t-name="wpc_portal.student_class_list">
        <div>
            <div class="d-flex justify-content-end">
                <h4 class="flex-grow-1 mb-0">My Classes</h4>
                <button type="button" class="btn btn-primary mb-2" data-bs-toggle="modal" data-bs-target="#modalAddExternalClass">
                  Add Additional Class
                </button>
            </div>
            <div class="portal_seperator m-0"/>
            <t t-if="!state.loading">
                <div class="table-responsive">
                    <table class="table table-hover table-wpc mb-0">
                        <tbody>
                            <t t-if="props.state &amp;&amp; props.state.class_list" t-foreach="props.state.class_list" t-as="class" t-key="class.id">
                                <tr t-on-click="()=> { class.selected = !class.selected }" >
                                    <td>
                                        <div class="form-check wpc-checkbox">
                                            <input t-attf-name="selected_class_{{ class.id }}" type="checkbox" class="form-check-input " t-model="class.selected"/>
                                        </div>
                                    </td>
                                     <td>
                                        <t t-esc="class.display_name"/>
                                     </td>
                                     <td>
                                        <t t-esc="class.framework"/>
                                     </td>
                                     <td>
                                         <div class="ps-3 pe-3 badge class-badge" t-attf-style="color: {{class.color }}; background: {{class.color }}33; border-color: {{class.color}}40;">
                                            <t t-esc="class.course"/>
                                         </div>
                                    </td>
                                </tr>
                            </t>
                        </tbody>
                    </table>
                    <div class="pb-3">
                        <a href="#" data-bs-toggle="modal" data-bs-target="#modalAddExternalClass">
                            View more...
                        </a>
                    </div>
                </div>

                <div class="modal fade" id="modalAddExternalClass" t-ref="modalAddExternalClassRef" tabindex="-1" aria-labelledby="modalAddExternalClass" aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h1 class="modal-title fs-5" id="modalAddExternalClassLabel">Select Delivery School/TAFE</h1>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
                            </div>
                            <div class="modal-body">
    <!--                            <div>-->
    <!--                                School Search:-->
    <!--                                <input type="text" t-model="state.school_name_search"/>-->
    <!--                            </div>-->
                                <div style="min-height: 400px;">
    <!--                                options="props.state.class_list.map(o => { return { value: o.id, text: o.display_name}})"-->
    <!--                                -->
                                    <div><strong>Select a school</strong></div>
                                    <IsTomSelect
                                        load="getSchoolListItems.bind(this)"
                                        valueField="'id'"
                                        labelField="'name'"
                                        searchField="'name'"
                                        settings="{maxItems: 1, placeholder: 'Search schools...'}"
                                        onChange="(o) => { state.selectedExtraSchoolId = o }"
                                    />

                                    <div class="list-group" t-if="state.selectedExtraSchoolId">
                                        <div><strong>Select an external class</strong></div>
                                        <t t-if="state.extra_class_list.length">
                                            <t t-foreach="state.extra_class_list" t-as="class" t-key="class.id">
                                                 <div class="list-group-item list-group-item-action" t-on-click="()=> { class.selected = !class.selected }">
                                                    <td>
                                                        <input type="checkbox" t-model="class.selected"/>
                                                    </td>
        <!--                                            <td>-->
        <!--                                                <t t-esc="class.id"/>-->
        <!--                                            </td>-->
                                                     <td>
                                                        <t t-esc="class.display_name"/>
                                                     </td>
                                                </div>
                                            </t>
                                        </t>
                                        <t t-elif="state.extra_class_list_loading">
                                            <div class="list-group-item list-group-item-action">
                                                <div class="placeholder-glow">
                                                    <span class="placeholder col-12"/>
                                                </div>
                                            </div>
                                            <div class="list-group-item list-group-item-action">
                                                <div class="placeholder-glow">
                                                    <span class="placeholder col-12"/>
                                                </div>
                                            </div>
                                        </t>
                                        <div t-else="">
                                            No external classes found.
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn" data-bs-dismiss="modal">Close</button>
                                <button type="button" class="btn btn-primary" t-on-click="addExternalClass.bind(this)" t-att-disabled="state.isSaving">Add</button>
                            </div>
                        </div>
                    </div>
                </div>
            </t>
            <t t-else="">
                <div class="table-responsive">
                    <table class="table table-hover table-wpc">
                        <tbody>
                            <t t-foreach="Array(8).fill(0)" t-as="x" t-key="x">
                                <tr>
                                    <td>
                                        <div class="placeholder-glow">
                                            <span class="placeholder col-12"></span>
                                        </div>
                                    </td>
                                </tr>
                            </t>
                        </tbody>
                    </table>
                </div>
            </t>
        </div>
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/components/student_placement_list/student_placement_list.xml": `<templates>
    <t t-name="wpc_portal.student_placement_list">
        <div>
            <h4>My Placements</h4>
            <div class="portal_seperator mt-0"/>
            <div class="table-responsive">
                <table class="table table-wpc">
                    <thead>
                        <tr>
                            <td>Start Date</td>
                            <td>End Date</td>
                            <td>Status</td>
                            <td>Course</td>
                            <td>Host</td>
                            <td>Address</td>
                            <td>Contact</td>
                            <td>Phone</td>
                        </tr>
                    </thead>
                    <tbody t-if="!state.loading">
                         <t t-if="props.state &amp;&amp; props.state.placement_list &amp;&amp; props.state.placement_list.length">
                            <tr t-foreach="props.state.placement_list" t-as="placement" t-key="placement.id">
                                <td t-esc="placement.start_date"/>
                                <td t-esc="placement.end_date"/>
                                <td t-esc="placement.status"/>
                                <td t-esc="placement.course"/>
                                <td t-esc="placement.host"/>
                                <td t-esc="placement.address"/>
                                <td t-esc="placement.contact"/>
                                <td t-esc="placement.phone"/>
                            </tr>
                         </t>
                         <t t-else="">
                             <tr>
                                 <td colspan="100" class="text-center">
                                     <span class="text-muted">You currently have no arranged placements. Your teacher will keep you informed.</span>
                                 </td>
                             </tr>
                         </t>
                    </tbody>
                    <tbody t-else="">
                        <t t-foreach="Array(1).fill(0)" t-as="x" t-key="x">
                            <tr>
                                <td t-foreach="Array(8).fill(0)" t-as="y" t-key="y">
                                    <div class="placeholder-glow">
                                        <span class="placeholder col-12"/>
                                    </div>
                                </td>
                            </tr>
                        </t>
                    </tbody>
                </table>
                <div class="btn btn-primary float-end" t-on-click="env.doLogout">Logout</div>
            </div>
        </div>
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/components/tom_select/tom_select.xml": `<?xml version="1.0" encoding="UTF-8" ?>
<templates xml:space="preserve">
    <t t-name="is_owl_components.IsTomSelect" owl="1">
        <select t-att-id="props.name" t-att-name="props.name" class="tom-select-search" t-ref="IsTomSelectEl" data-live-search="true" t-att-data-required="props.required"/>
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/pages/home/home.xml": `<?xml version="1.0" encoding="UTF-8"?>
<templates xml:space="preserve">
    <t t-name="wpc_portal.wpc_portal_root_home_component" owl="1">
        <t t-call="wpc_portal.wpc_portal_root_layout">
            <t t-set="currentPage" t-value="'home'"/>

            <t t-if="state.hash === 'students'">
                <t t-call="wpc_portal.wpc_portal_root_home_students_component"/>
            </t>
            <t t-elif="state.hash === 'teachers'">
                <t t-call="wpc_portal.wpc_portal_root_home_teachers_component"/>
            </t>
            <t t-elif="state.hash === 'employers'">
                <t t-call="wpc_portal.wpc_portal_root_home_employers_component"/>
            </t>
            <t t-elif="state.hash === 'contact'">
                <t t-call="wpc_portal.wpc_portal_root_home_contact_component"/>
            </t>
            <t t-elif="state.hash === 'resources'">
                <WPCResourcesPage/>
            </t>
            <t t-else="">
                <t t-call="wpc_portal.wpc_portal_root_home_home_component"/>
            </t>
        </t>
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/pages/home/home_contact.xml": `<?xml version="1.0" encoding="UTF-8"?>
<templates xml:space="preserve">
    <t t-name="wpc_portal.wpc_portal_root_home_contact_component" owl="1">
        <section class="wpc-hero">
            <div class="container text-center text-white position-relative" style="z-index:1;">
                <span class="badge rounded-pill mb-3 px-3 py-2"
                      style="background:rgba(230,92,0,.18); color:#f97316; font-size:.8rem; letter-spacing:.06em;">
                    SCHOOLS INDUSTRY PARTNERSHIP
                </span>
                <h1 class="display-5 fw-bold mb-3" style="line-height:1.25;">
                    Contact Us
                </h1>
                <p class="mb-4 mx-auto" style="color:rgba(255,255,255,.7); max-width:540px; font-size:1.1rem; line-height:1.65;">
                    Get in touch with the Work Placement Connect team.
                </p>
                <div class="d-flex gap-3 justify-content-center flex-wrap">
                    <a href="https://schoolsindustry.com.au/contact" target="_blank" class="btn btn-lg px-4 fw-semibold"
                       style="background:var(--wpc-orange); color:#fff; border-radius:50px; box-shadow:0 4px 16px rgba(230,92,0,.4);">
                        Contact Us
                    </a>
                    <a href="#resources" class="btn btn-lg btn-outline-light px-4 fw-semibold"
                       style="border-radius:50px;">
                        Learn More
                    </a>
                </div>
            </div>
        </section>

        <div class="row g-0">
            <t t-call="wpc_portal.wpc_portal_root_industry_block_layout"/>
            <div class="col-lg-7 info-section p-4 p-lg-5 d-flex align-items-start">
                <div>
                    <p class="section-eyebrow mb-3">Contact Us</p>
                    <h5 class="fw-bold text-white mb-4" style="font-size:1.2rem; line-height:1.55;">
                        Work Placement is a great way to evidence your skills on your resume.
                    </h5>
                    <ul style="padding-left:1.25rem;">
                        <li>
                            The <a href="https://www.schoolsindustry.com.au/" target="_blank">Schools Industry Partnership</a> works with schools and employers to help train students in a wide range of Industry Curriculum Frameworks.
                        </li>
                        <li>
                            Please also visit <a href="https://go2workplacement.com/" target="_blank">go2workplacement.com</a> to complete your Work Placement Ready certificates before your first placements.
                        </li>
                        <li>
                            Have fun at your placements. Learn heaps and please give us your feedback.
                        </li>
                        <li>
                            Please check the <a href="#resources">Resources</a> webpage for instructions and documentation on how to use Work Placement Connect.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/pages/home/home_employers.xml": `<?xml version="1.0" encoding="UTF-8"?>
<templates xml:space="preserve">
    <t t-name="wpc_portal.wpc_portal_root_home_employers_component" owl="1">
        <section class="wpc-hero">
            <div class="container text-center text-white position-relative" style="z-index:1;">
                <span class="badge rounded-pill mb-3 px-3 py-2"
                      style="background:rgba(230,92,0,.18); color:#f97316; font-size:.8rem; letter-spacing:.06em;">
                    SCHOOLS INDUSTRY PARTNERSHIP
                </span>
                <h1 class="display-5 fw-bold mb-3" style="line-height:1.25;">
                    Work Placement for Employers
                </h1>
                <p class="mb-4 mx-auto" style="color:rgba(255,255,255,.7); max-width:540px; font-size:1.1rem; line-height:1.65;">
                    Partner with schools to host students and help shape the next generation of industry professionals.
                </p>
                <div class="d-flex gap-3 justify-content-center flex-wrap">
                    <a href="/portal" class="btn btn-lg px-4 fw-semibold"
                       style="background:var(--wpc-orange); color:#fff; border-radius:50px; box-shadow:0 4px 16px rgba(230,92,0,.4);">
                        Get Started
                    </a>
                    <a href="#resources" class="btn btn-lg btn-outline-light px-4 fw-semibold"
                       style="border-radius:50px;">
                        Learn More
                    </a>
                </div>
            </div>
        </section>

        <div class="row g-0">
            <t t-call="wpc_portal.wpc_portal_root_industry_block_layout"/>

            <div class="col-lg-7 info-section p-4 p-lg-5 d-flex align-items-start">
                <div>
                    <p class="section-eyebrow mb-3">For Employers</p>
                    <h5 class="fw-bold text-white mb-4" style="font-size:1.2rem; line-height:1.55;">
                        Employers can use this site to:
                    </h5>
                    <ul style="padding-left:1.25rem;">
                        <li>Express an interest in Work Placement</li>
                        <li><a href="https://schoolsindustry.com.au/work-placement-2/for-employers/" target="_blank">Link to more detailed information</a></li>
                        <li><a href="https://schoolsindustry.com.au/contact/" target="_blank">Contact your service provider</a></li>
                    </ul>
                </div>
            </div>
        </div>

<!--        <div class="modal fade" id="loginModal" tabindex="-1" aria-hidden="true">-->
<!--            <div class="modal-dialog modal-dialog-centered">-->
<!--                <div class="modal-content border-0 shadow-lg" style="border-radius:16px; overflow:hidden;">-->
<!--                    <div class="modal-body p-4">-->
<!--                        <WPCPortalLogin-->
<!--                            auth="env.wpc_state.auth"-->
<!--                            page_params="state.page_params"-->
<!--                            page_message="state.message"-->
<!--                            show_close="true"/>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/pages/home/home_home.xml": `<?xml version="1.0" encoding="UTF-8"?>
<templates xml:space="preserve">
    <t t-name="wpc_portal.wpc_portal_root_home_home_component" owl="1">
        <section class="wpc-hero">
            <div class="container text-center text-white position-relative" style="z-index:1;">
                <span class="badge rounded-pill mb-3 px-3 py-2"
                      style="background:rgba(230,92,0,.18); color:#f97316; font-size:.8rem; letter-spacing:.06em;">
                    SCHOOLS INDUSTRY PARTNERSHIP
                </span>
                <h1 class="display-5 fw-bold mb-3" style="line-height:1.25;">
                    Connecting Students, Teachers<br class="d-none d-md-block"/> &amp; Employers
                </h1>
                <p class="mb-4 mx-auto" style="color:rgba(255,255,255,.7); max-width:540px; font-size:1.1rem; line-height:1.65;">
                    Build real-world industry experience and evidence your skills on your resume through structured work placements.
                </p>
                <div class="d-flex gap-3 justify-content-center flex-wrap">
                    <a href="/portal" class="btn btn-lg px-4 fw-semibold"
                       style="background:var(--wpc-orange); color:#fff; border-radius:50px; box-shadow:0 4px 16px rgba(230,92,0,.4);">
                        Get Started
                    </a>
                    <a href="#resources" class="btn btn-lg btn-outline-light px-4 fw-semibold"
                       style="border-radius:50px;">
                        Learn More
                    </a>
                </div>
            </div>
        </section>

        <div class="row g-0">
            <t t-call="wpc_portal.wpc_portal_root_industry_block_layout"/>
            <div class="col-lg-7 info-section p-4 p-lg-5 d-flex align-items-start">
                <div>
                    <p class="section-eyebrow mb-3">About Work Placement</p>
                    <h5 class="fw-bold text-white mb-4" style="font-size:1.2rem; line-height:1.55;">
                        Work Placement is a great way to evidence your skills on your resume.
                    </h5>
                    <ul style="padding-left:1.25rem;">
                        <li>
                            The <a href="https://www.schoolsindustry.com.au/" target="_blank">Schools Industry Partnership</a> works with schools and
                            employers to help train students in a wide range of Industry Curriculum Frameworks.
                        </li>
                        <li>
                            Please also visit <a href="https://go2workplacement.com/" target="_blank">go2workplacement.com</a> to complete your
                            Work Placement Ready certificates before your first placements.
                        </li>
                        <li>
                            Have fun at your placements. Learn heaps and please give us your feedback.
                        </li>
                        <li>
                            Please check the <a href="#resources">Resources</a> webpage for instructions
                            and documentation on how to use Work Placement Connect.
                        </li>
                    </ul>
                </div>
            </div>
        </div>

<!--        <div class="modal fade" id="loginModal" tabindex="-1" aria-hidden="true">-->
<!--            <div class="modal-dialog modal-dialog-centered">-->
<!--                <div class="modal-content border-0 shadow-lg" style="border-radius:16px; overflow:hidden;">-->
<!--                    <div class="modal-body p-4">-->
<!--                        <WPCPortalLogin-->
<!--                            auth="env.wpc_state.auth"-->
<!--                            page_params="state.page_params"-->
<!--                            page_message="state.message"-->
<!--                            show_close="true"/>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/pages/home/home_resources.xml": `<?xml version="1.0" encoding="UTF-8"?>
<templates xml:space="preserve">
    <t t-name="wpc_portal.wpc_portal_root_home_resources_component" owl="1">
        <!-- Hero -->
        <section class="wpc-hero">
            <div class="container text-center text-white position-relative" style="z-index:1;">
                <span class="badge rounded-pill mb-3 px-3 py-2"
                      style="background:rgba(230,92,0,.18); color:#f97316; font-size:.8rem; letter-spacing:.06em;">
                    SCHOOLS INDUSTRY PARTNERSHIP
                </span>
                <h1 class="display-5 fw-bold mb-3" style="line-height:1.25;">
                    Resources
                </h1>
                <p class="mb-4 mx-auto" style="color:rgba(255,255,255,.7); max-width:540px; font-size:1.1rem; line-height:1.65;">
                    Instructions, documentation and guides for using Work Placement Connect.
                </p>
            </div>
        </section>

        <!-- Tab Bar -->
        <div class="resource-tabs-wrapper">
            <div class="container">
                <ul class="resource-tabs nav">
                    <li class="nav-item">
                        <a t-attf-class="nav-link #{state.tab === 'documents' ? 'active' : ''}"
                           href="#" t-on-click.prevent="() => this.switchTab('documents')">
                            DOCUMENTS
                        </a>
                    </li>
                    <li class="nav-item">
                        <a t-attf-class="nav-link #{state.tab === 'blog' ? 'active' : ''}"
                           href="#" t-on-click.prevent="() => this.switchTab('blog')">
                            BLOG
                        </a>
                    </li>
                    <li class="nav-item">
                        <a t-attf-class="nav-link #{state.tab === 'videos' ? 'active' : ''}"
                           href="#" t-on-click.prevent="() => this.switchTab('videos')">
                            VIDEOS
                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Tab Content -->
        <div class="container py-4">

            <!-- ============ DOCUMENTS TAB ============ -->
            <t t-if="state.tab === 'documents'">
                <!-- Loading -->
                <t t-if="state.loading.documents">
                    <div class="row g-3">
                        <t t-foreach="[1,2,3,4,5,6]" t-as="i" t-key="i">
                            <div class="col-12 col-sm-6 col-md-3">
                                <div class="card resource-card">
                                    <div class="skeleton skeleton-img"></div>
                                    <div class="card-body">
                                        <div class="skeleton skeleton-title"></div>
                                        <div class="skeleton skeleton-text"></div>
                                        <div class="skeleton skeleton-text short"></div>
                                    </div>
                                    <div class="card-footer border-0 bg-transparent p-3 pt-0">
                                        <div class="skeleton skeleton-btn"></div>
                                    </div>
                                </div>
                            </div>
                        </t>
                    </div>
                </t>

                <!-- Error -->
                <t t-elif="state.error.documents">
                    <div class="alert alert-danger"><t t-esc="state.error.documents"/></div>
                </t>

                <!-- Content -->
                <t t-elif="state.documents">
                    <!-- Top-level documents -->
                    <t t-if="state.documents.documents and state.documents.documents.length">
                        <div class="row g-3 mb-4">
                            <t t-foreach="state.documents.documents" t-as="doc" t-key="doc.id">
                                <div class="col-12 col-sm-6 col-md-3">
                                    <div class="card resource-card h-100">
                                        <t t-if="doc.image_url and doc.image_url.url">
                                            <img t-att-src="doc.image_url.url"
                                                 t-att-alt="doc.image_url.description || doc.title"
                                                 class="card-img-top resource-card-img"/>
                                        </t>
                                        <t t-else="">
                                            <div class="resource-card-icon">
                                                <i t-attf-class="#{getFileIcon(doc.name)}" style="font-size:3rem;"></i>
                                            </div>
                                        </t>
                                        <div class="card-body">
                                            <h5 class="card-title"><t t-esc="doc.title"/></h5>
                                            <p t-if="doc.description" class="card-text text-muted small mb-2"><t t-esc="doc.description"/></p>
                                            <p class="card-text text-muted small">
                                                <i class="bi bi-file-earmark me-1"></i><t t-esc="doc.name"/>
                                            </p>
                                        </div>
                                        <div class="card-footer border-0 bg-transparent p-3 pt-0">
                                            <a t-att-href="doc.download_url" class="btn btn-primary w-100">Download</a>
                                        </div>
                                    </div>
                                </div>
                            </t>
                        </div>
                    </t>

                    <!-- Folders -->
                    <t t-foreach="state.documents.folders" t-as="folder" t-key="folder.id">
                        <div class="resource-folder-group">
                            <h4 class="mb-3"><t t-esc="folder.name"/></h4>
                            <div class="row g-3">
                                <t t-foreach="folder.documents" t-as="doc" t-key="doc.id">
                                    <div class="col-12 col-sm-6 col-md-3">
                                        <div class="card resource-card h-100">
                                            <t t-if="doc.image_url and doc.image_url.url">
                                                <img t-att-src="doc.image_url.url"
                                                     t-att-alt="doc.image_url.description || doc.title"
                                                     class="card-img-top resource-card-img"/>
                                            </t>
                                            <t t-else="">
                                                <div class="resource-card-icon">
                                                    <i t-attf-class="#{getFileIcon(doc.name)}" style="font-size:3rem;"></i>
                                                </div>
                                            </t>
                                            <div class="card-body">
                                                <h5 class="card-title"><t t-esc="doc.title"/></h5>
                                                <p t-if="doc.description" class="card-text text-muted small mb-2"><t t-esc="doc.description"/></p>
                                                <p class="card-text text-muted small">
                                                    <i class="bi bi-file-earmark me-1"></i><t t-esc="doc.name"/>
                                                </p>
                                            </div>
                                            <div class="card-footer border-0 bg-transparent p-3 pt-0">
                                                <a t-att-href="doc.download_url" class="btn btn-primary w-100">Download</a>
                                            </div>
                                        </div>
                                    </div>
                                </t>
                            </div>
                        </div>
                    </t>
                </t>
            </t>

            <!-- ============ BLOG TAB ============ -->
            <t t-if="state.tab === 'blog'">
                <!-- Loading -->
                <t t-if="state.loading.blog">
                    <div class="row g-3">
                        <t t-foreach="[1,2,3,4,5,6]" t-as="i" t-key="i">
                            <div class="col-12 col-sm-6 col-md-4">
                                <div class="card resource-card">
                                    <div class="skeleton skeleton-img" style="height:200px;"></div>
                                    <div class="card-body">
                                        <div class="skeleton skeleton-title"></div>
                                        <div class="skeleton skeleton-text"></div>
                                        <div class="skeleton skeleton-text"></div>
                                        <div class="skeleton skeleton-text short"></div>
                                    </div>
                                    <div class="card-footer border-0 bg-transparent p-3 pt-0">
                                        <div class="skeleton skeleton-btn" style="width:120px;"></div>
                                    </div>
                                </div>
                            </div>
                        </t>
                    </div>
                </t>

                <!-- Error -->
                <t t-elif="state.error.blog">
                    <div class="alert alert-danger"><t t-esc="state.error.blog"/></div>
                </t>

                <!-- Content -->
                <t t-elif="state.blog">
                    <div class="row g-3">
                        <t t-foreach="state.blog" t-as="post" t-key="post.ID">
                            <div class="col-12 col-sm-6 col-md-4">
                                <div class="card resource-card h-100">
                                    <img t-att-src="post.featured_image || 'https://schoolsindustryblog.files.wordpress.com/2018/10/vectorstock_19911069.jpg?w=900'"
                                         t-att-alt="post.title"
                                         class="card-img-top"
                                         style="height:200px; object-fit:cover;"/>
                                    <div class="card-body">
                                        <h5 class="card-title" t-esc="post.title"/>
                                        <p class="text-muted small mb-2"><t t-esc="formatDate(post.date)"/></p>
                                        <div class="card-text small text-muted" t-out="post.excerpt"/>
                                    </div>
                                    <div class="card-footer border-0 bg-transparent p-3 pt-0">
                                        <a t-att-href="post.URL" target="_blank"
                                           class="btn btn-primary">
                                            Read More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </t>
                    </div>
                </t>
            </t>

            <!-- ============ VIDEOS TAB ============ -->
            <t t-if="state.tab === 'videos'">
                <!-- Loading -->
                <t t-if="state.loading.videos">
                    <div class="row g-3">
                        <t t-foreach="[1,2,3,4,5,6]" t-as="i" t-key="i">
                            <div class="col-12 col-sm-6 col-md-4">
                                <div class="skeleton skeleton-img" style="height:190px; border-radius:8px;"></div>
                            </div>
                        </t>
                    </div>
                </t>

                <!-- Error -->
                <t t-elif="state.error.videos">
                    <div class="alert alert-danger"><t t-esc="state.error.videos"/></div>
                </t>

                <!-- Content -->
                <t t-elif="state.videos">
                    <div class="row g-3">
                        <t t-foreach="state.videos" t-as="video" t-key="video.id">
                            <div class="col-12 col-sm-6 col-md-4">
                                <div class="video-tile" t-on-click="() => this.openVideo(video.id)">
                                    <div class="video-tile-thumb">
                                        <img t-att-src="video.thumbnail_url" t-att-alt="video.title"/>
                                    </div>
                                    <div class="video-tile-bar">
                                        <div class="video-tile-title" t-esc="video.title"/>
                                        <div class="video-tile-subtitle">
                                            <t t-esc="video.channel_title"/> - <t t-esc="video.duration"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </t>
                    </div>
                </t>
            </t>

        </div>
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/pages/home/home_students.xml": `<?xml version="1.0" encoding="UTF-8"?>
<templates xml:space="preserve">
    <t t-name="wpc_portal.wpc_portal_root_home_students_component" owl="1">
        <section class="wpc-hero">
            <div class="container text-center text-white position-relative" style="z-index:1;">
                <span class="badge rounded-pill mb-3 px-3 py-2"
                      style="background:rgba(230,92,0,.18); color:#f97316; font-size:.8rem; letter-spacing:.06em;">
                    SCHOOLS INDUSTRY PARTNERSHIP
                </span>
                <h1 class="display-5 fw-bold mb-3" style="line-height:1.25;">
                    Work Placement for Students
                </h1>
                <p class="mb-4 mx-auto" style="color:rgba(255,255,255,.7); max-width:540px; font-size:1.1rem; line-height:1.65;">
                    Build real-world industry experience and evidence your skills on your resume through structured work placements.
                </p>
                <div class="d-flex gap-3 justify-content-center flex-wrap">
                    <a href="/portal" class="btn btn-lg px-4 fw-semibold"
                       style="background:var(--wpc-orange); color:#fff; border-radius:50px; box-shadow:0 4px 16px rgba(230,92,0,.4);">
                        Get Started
                    </a>
                    <a href="#resources" class="btn btn-lg btn-outline-light px-4 fw-semibold"
                       style="border-radius:50px;">
                        Learn More
                    </a>
                </div>
            </div>
        </section>

        <div class="row g-0">
            <t t-call="wpc_portal.wpc_portal_root_industry_block_layout"/>

            <div class="col-lg-7 info-section p-4 p-lg-5 d-flex align-items-start">
                <div>
                    <p class="section-eyebrow mb-3">For Students</p>
                    <h5 class="fw-bold text-white mb-4" style="font-size:1.2rem; line-height:1.55;">
                        Work Placement is a great way to evidence your skills on your resume.
                    </h5>
                    <ul style="padding-left:1.25rem;">
                        <li>
                            The <a href="https://www.schoolsindustry.com.au/" target="_blank">Schools Industry Partnership</a> works with schools and
                            employers to help train students in a wide range of Industry Curriculum Frameworks.
                        </li>
                        <li>
                            Please also visit <a href="https://go2workplacement.com/" target="_blank">go2workplacement.com</a> to complete your
                            Work Placement Ready certificates before your first placements.
                        </li>
                        <li>Have fun at your placements. Learn heaps and please give us your feedback.</li>
                        <li>
                            Please check the <a href="#resources">Resources</a> webpage for instructions
                            and documentation on how to use Work Placement Connect.
                        </li>
                    </ul>
                </div>
            </div>
        </div>

<!--        <div class="modal fade" id="loginModal" tabindex="-1" aria-hidden="true">-->
<!--            <div class="modal-dialog modal-dialog-centered">-->
<!--                <div class="modal-content border-0 shadow-lg" style="border-radius:16px; overflow:hidden;">-->
<!--                    <div class="modal-body p-4">-->
<!--                        <WPCPortalLogin-->
<!--                            auth="env.wpc_state.auth"-->
<!--                            page_params="state.page_params"-->
<!--                            page_message="state.message"-->
<!--                            show_close="true"/>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/pages/home/home_teachers.xml": `<?xml version="1.0" encoding="UTF-8"?>
<templates xml:space="preserve">
    <t t-name="wpc_portal.wpc_portal_root_home_teachers_component" owl="1">
        <section class="wpc-hero">
            <div class="container text-center text-white position-relative" style="z-index:1;">
                <span class="badge rounded-pill mb-3 px-3 py-2"
                      style="background:rgba(230,92,0,.18); color:#f97316; font-size:.8rem; letter-spacing:.06em;">
                    SCHOOLS INDUSTRY PARTNERSHIP
                </span>
                <h1 class="display-5 fw-bold mb-3" style="line-height:1.25;">
                    Work Placement for Teachers
                </h1>
                <p class="mb-4 mx-auto" style="color:rgba(255,255,255,.7); max-width:540px; font-size:1.1rem; line-height:1.65;">
                    Build real-world industry experience and evidence your skills on your resume through structured work placements.
                </p>
                <div class="d-flex gap-3 justify-content-center flex-wrap">
                    <a href="/portal" class="btn btn-lg px-4 fw-semibold"
                       style="background:var(--wpc-orange); color:#fff; border-radius:50px; box-shadow:0 4px 16px rgba(230,92,0,.4);">
                        Get Started
                    </a>
                    <a href="#resources" class="btn btn-lg btn-outline-light px-4 fw-semibold"
                       style="border-radius:50px;">
                        Learn More
                    </a>
                </div>
            </div>
        </section>

        <div class="row g-0">
            <t t-call="wpc_portal.wpc_portal_root_industry_block_layout"/>

            <div class="col-lg-7 info-section p-4 p-lg-5 d-flex align-items-start">
                <div>
                    <p class="section-eyebrow mb-3">For Teachers</p>
                    <h5 class="fw-bold text-white mb-4" style="font-size:1.2rem; line-height:1.55;">
                        Registered teachers can use this site to:
                    </h5>
                    <ul style="padding-left:1.25rem;">
                        <li>Register new classes for Work Placement</li>
                        <li>Bid for Placement Blocks on the annual Work Placement Calendar</li>
                        <li>Monitor new student Sign&#8209;Ups and cancelations</li>
                        <li>Match students to placement offers</li>
                        <li>View student feedback post placement</li>
                        <li>Print placement paperwork and certificates</li>
                    </ul>
                </div>
            </div>
        </div>

<!--        <div class="modal fade" id="loginModal" tabindex="-1" aria-hidden="true">-->
<!--            <div class="modal-dialog modal-dialog-centered">-->
<!--                <div class="modal-content border-0 shadow-lg" style="border-radius:16px; overflow:hidden;">-->
<!--                    <div class="modal-body p-4">-->
<!--                        <WPCPortalLogin-->
<!--                            auth="env.wpc_state.auth"-->
<!--                            page_params="state.page_params"-->
<!--                            page_message="state.message"-->
<!--                            show_close="true"/>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/pages/home/home_test.xml": `<?xml version="1.0" encoding="UTF-8"?>
<templates xml:space="preserve">
    <t t-name="wpc_portal.wpc_portal_root_home_component" owl="1">
        <style>


.login-btn {
    background-color: #E65C00;
    color: #fff;
    border-radius: 50px;
    padding: 8px 20px;
}

.login-btn:hover {
    background-color: #CF5200;
    color: #fff;
}
</style>

<nav class="navbar navbar-expand-lg navbar-light bg-white border-bottom py-3">
        <div class="container-fluid">

              <div class="navbar-brand ms-2 d-flex align-items-center">
                <img src="/static/img/logo.png" class="me-1 ms-1" style="max-width: 50px;"/>
                <strong class="d-none d-md-block" style="font-size: larger;">Work Placement Connect</strong>
<!--                        <div class="ms-2 badge bg-wpc " t-if="env.wpc_state.auth.role" style="    font-size: x-small;"><t t-esc="env.wpc_state.auth.role"/> Portal</div>-->
            </div>

                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mainNav">
                        <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="mainNav">
                        <ul class="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center">
                                <li class="nav-item">
                                    <a t-attf-class="nav-link {{ state.page_name === 'home' &amp;&amp; 'active' }}" href="#">Home</a>
                                </li>
                                <li class="nav-item">
                                    <a t-attf-class="nav-link {{ state.page_name === 'teachers' &amp;&amp; 'active' }}" href="#teachers">Teachers</a>
                                </li>
                                <li class="nav-item">
                                    <a t-attf-class="nav-link {{ state.page_name === 'students' &amp;&amp; 'active' }}" href="#students">Students</a>
                                </li>
                                <li class="nav-item">
                                    <a t-attf-class="nav-link {{ state.page_name === 'employers' &amp;&amp; 'active' }}" href="#employers">Employers</a>
                                </li>
                                <li class="nav-item">
                                    <a t-attf-class="nav-link {{ state.page_name === 'resources' &amp;&amp; 'active' }}" href="#resources">Resources</a>
                                </li>
                                <li class="nav-item">
                                    <a t-attf-class="nav-link {{ state.page_name === 'contact' &amp;&amp; 'active' }}" href="#contact">Contact Us</a>
                                </li>
                                <li class="nav-item ms-lg-3">
<!--                                        <a class="btn login-btn" href="/portal">Login</a> -->
                                    <div class="d-flex align-items-start">
                                        <WPCPortalAccountStatus t-if="env.wpc_state.auth.role" currentPage="'home'"/>
                                        <a t-else="" href="#" data-bs-toggle="modal" data-bs-target="#loginModal" class="btn login-btn">
                                            Login / Register</a>
                                    </div>
                                </li>
                        </ul>
                </div>

        </div>
</nav>

    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/pages/portal/portal.xml": `<?xml version="1.0" encoding="UTF-8"?>
<templates xml:space="preserve">
    <t t-name="wpc_portal.wpc_portal_root_portal_component" owl="1">
        <t t-call="wpc_portal.wpc_portal_root_layout">
            <t t-set="currentPage" t-value="'portal'"/>
            <div t-if="!env.wpc_state.auth.loaded">
                <div class="w-100 vh-100 d-flex align-items-center justify-content-center">
                    <div class="lds-ring text-center"><div class="wpc_loading"/><div class="wpc_loading"/><div class="wpc_loading"/><div class="wpc_loading"/></div>
                </div>
            </div>
            <t t-else="">
                <div class="mb-0 p-2 wpc_panel d-flex d-flex justify-content-between align-items-center">
<!--                    <div class="ms-2 d-flex align-items-center">-->
<!--                        <img src="/static/img/logo.png" class="me-1 ms-1" style="max-width: 50px;"/>-->
<!--                        <strong class="d-none d-md-block" style="font-size: larger;">Work Placement Connect</strong>-->
<!--    &lt;!&ndash;                        <div class="ms-2 badge bg-wpc " t-if="env.wpc_state.auth.role" style="    font-size: x-small;"><t t-esc="env.wpc_state.auth.role"/> Portal</div>&ndash;&gt;-->
<!--                    </div>-->
<!--                    <div class="d-md-flex d-none align-items-start">-->
<!--                        <WPCPortalAccountStatus t-if="env.wpc_state.auth.role" currentPage="'portal'"/>-->
<!--                    </div>-->
                    <a class="d-md-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#mobileMenu" aria-controls="mobileMenu">
                        <i class="bi bi-list text-wpc" style="font-size:32px;"/>
                    </a>
                </div>
                <div class="offcanvas offcanvas-start" tabindex="-1" id="mobileMenu" aria-labelledby="mobileMenuLabel" style="max-width: 80%;">
                    <div class="offcanvas-header">
                        <WPCPortalAccountStatus t-if="env.wpc_state.auth.role" currentPage="'portal'"/>
                        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Back"/>
                    </div>
                    <div class="offcanvas-body">
                        <div class="d-flex flex-column">
                            <t t-call="wpc_portal.menu"/>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-row flex-grow-1" t-if="env.wpc_state.auth.step !== 'valid'">
                    <div class="p-0 wpc_panel flex-grow-1 d-flex align-items-center flex-column">
                        <WPCPortalLogin auth="env.wpc_state.auth" page_params="state.page_params" page_message="state.message" />
                    </div>
                </div>
                <div class="d-flex flex-row flex-grow-1 portal-container" t-else="">
                    <div class="p-0 wpc_panel d-none d-md-block">
                        <t t-call="wpc_portal.menu"/>
                    </div>
                    <WPCPortalStudentPortal t-if="env.wpc_state.auth.role == 'Student'" wpc_state="env.wpc_state"/>
                    <WPCPortalTeacherPortal t-if="['Teacher', 'Admin'].includes(env.wpc_state.auth.role)"/>
    <!--                        <div>-->
    <!--                            <strong>State</strong><br/>-->
    <!--                            <pre t-esc="window.JSON.stringify(env.wpc_state, null, 4)"/>-->
    <!--                        </div>-->
                </div>
            </t>
        </t>
    </t>
    <t t-name="wpc_portal.menu" owl="1">
            <div class="d-flex flex-column wpc-menu">
                <t t-if="state.menus" t-foreach="state.menus" t-as="menu" t-key="menu.id">
                    <a href="#" t-on-click="()=>{ changeSelectedMenu.bind(this)(menu, menu_index) }" t-attf-class="ps-0 ps-md-5 item {{ state.currentMenu === menu.id ? 'active' : '' }}">
                        <i t-attf-class="{{menu.icon}} me-2" t-if="menu.icon"/>
                        <span t-esc="menu.name"/>
                    </a>
                </t>
            </div>
        </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/pages/student_portal/student_portal.xml": `<templates>
    <t t-name="wpc_portal.student_portal">
        <form t-on-submit.prevent="onSubmit" class="form w-100">
            <div class="d-flex  flex-column flex-md-row ms-3 me-3 mt-4 mb-3">
                <h3 class="ps-3 mb-0 flex-grow-1 fw-bold">Student Portal</h3>
                <div class="ps-3 ps-md-0 mt-2 mt-md-0 d-flex flex-row-reverse">
                    <button type="submit" name="moveNextPage" class="btn btn-primary btn-rnd" t-att-disabled="state.saving">
                        Save &amp; Continue
                    </button>
                    <div class="btn btn-secondary btn-rnd me-2" t-if="props.wpc_state.hasPreviousMenu" t-on-click="()=>{ this.props.wpc_state.goPreviousMenu(); }">
                        Go Back
                    </div>
                </div>
            </div>
            <div class="m-3 p-4 flex-grow-1 wpc_panel rnd">
                <div>
                        <input name="new_studentid" type="hidden" t-model="state.profile.new_studentid"/>
                        <t t-if="props.wpc_state.currentMenu == 'school_details'" t-call="wpc_portal.student_portal_school_details"/>
                        <t t-if="props.wpc_state.currentMenu == 'personal_details'" t-call="wpc_portal.student_portal_personal_details"/>
                        <t t-if="props.wpc_state.currentMenu == 'address'" t-call="wpc_portal.student_portal_address"/>
                        <t t-if="props.wpc_state.currentMenu == 'medical_details'" t-call="wpc_portal.student_portal_medical_details"/>
                        <t t-if="props.wpc_state.currentMenu == 'guardian_details'" t-call="wpc_portal.student_portal_guardian_details"/>
                        <t t-if="props.wpc_state.currentMenu == 'my_classes'" t-call="wpc_portal.student_portal_my_classes"/>
                        <t t-if="props.wpc_state.currentMenu == 'my_placements'" t-call="wpc_portal.student_portal_my_placements"/>
<!--                        <div class="d-flex justify-content-between">-->
<!--        &lt;!&ndash;                    <button type="submit" name="movePreviousPage" id="moveNextPage" class="btn btn-primary" t-att-disabled="state.saving">&ndash;&gt;-->
<!--        &lt;!&ndash;                        Back&ndash;&gt;-->
<!--        &lt;!&ndash;                    </button>&ndash;&gt;-->
<!--                            <div class="btn" t-if="props.wpc_state.hasPreviousMenu" t-on-click="()=>{ this.props.wpc_state.goPreviousMenu(); }">-->
<!--                                Go Back-->
<!--                            </div>-->
<!--                            <div t-else=""/>-->
<!--                            <button type="submit" name="moveNextPage" class="btn btn-primary" t-att-disabled="state.saving">-->
<!--                                Save &amp; Continue-->
<!--                            </button>-->
<!--                        </div>-->
                </div>
            </div>
        </form>
<!--        <div>-->
<!--            <strong>Student State</strong><br/>-->
<!--            <pre t-esc="window.JSON.stringify(state, null, 4)"/>-->
<!--&lt;!&ndash;            <pre t-esc="window.JSON.stringify(env.wpc_student_state, null, 4)"/>&ndash;&gt;-->
<!--        </div>-->
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/pages/teacher_portal/teacher_portal.xml": `<templates>
    <t t-name="wpc_portal.teacher_portal">
        <div class="m-3 p-4 flex-grow-1 wpc_panel rnd">
            <div>
            [TEACHER PORTAL]
            </div>
        </div>
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/pages/student_portal/views/address.xml": `<templates>
    <t t-name="wpc_portal.student_portal_address">
        <div>
            <h4>Address</h4>
            <div class="portal_seperator mt-0"/>

<!--            <div class="form-group mb-3">-->
<!--              <label for="new_suburb">Suburb<sup>(1)</sup></label>-->
<!--              <input t-model="state.profile.new_suburb" type="text" class="form-control" name="new_suburb" placeholder="Suburb"/>-->
<!--            </div>-->

<!--            <div class="form-group mb-3">-->
<!--              <label for="new_postcode">Postcode</label>-->
<!--              <input t-model="state.profile.new_postcode" type="text" class="form-control" name="new_postcode" placeholder="Postcode"/>-->
<!--            </div>-->

<!--            <div class="form-group mb-3" style="font-size: x-small;">-->
<!--                <p class="text-muted">-->
<!--                    (1) We will attempt to secure placements within reasonable travel distances.-->
<!--                </p>-->
<!--            </div>-->
        </div>
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/pages/student_portal/views/guardian_details.xml": `<templates>
    <t t-name="wpc_portal.student_portal_guardian_details">
        <div>
           <h4>Parent/Carer Details</h4>
            <div class="portal_seperator mt-0"/>
            <div class="form-group mb-3">
              <label for="new_guardianfn">Parent/Carer Name</label>
              <input t-model="state.profile.new_guardianfn" type="text" class="form-control" name="new_guardianfn" placeholder="Guardian Name"/>
            </div>
            <div class="form-group mb-3">
              <label for="new_guardianrelation">Relation to you</label>
              <input t-model="state.profile.new_guardianrelation" type="text" class="form-control" name="new_guardianrelation" placeholder="Relation to you"/>
            </div>
            <div class="form-group mb-3">
              <label for="new_guardianphone">Parent/Carer Mobile</label>
              <input t-model="state.profile.new_guardianphone" type="text" class="form-control" name="new_guardianphone" placeholder="Guardian Mobile"/>
            </div>
            <div class="form-group mb-3">
              <label for="new_guardianmobile">Work Phone</label>
              <input t-model="state.profile.new_guardianmobile" type="text" class="form-control" name="new_guardianmobile" placeholder="Guardian Day Phone"/>
            </div>
            <div class="form-group mb-3">
              <label for="sip_guardianemail">Parent/Carer Email</label>
              <input t-model="state.profile.sip_guardianemail" type="text" class="form-control" name="sip_guardianemail" placeholder="Guardian Email"/>
            </div>
        </div>
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/pages/student_portal/views/medical_details.xml": `<templates>
    <t t-name="wpc_portal.student_portal_medical_details">
        <div>
           <h4>Medical Details</h4>
            <div class="portal_seperator mt-0"/>

<!--            <div class="form-group mb-3">-->
<!--              <label for="new_studentmedicareno">Medicare Number</label>-->
<!--              <input t-model="state.profile.new_studentmedicareno" type="text" class="form-control" name="new_studentmedicareno" placeholder="Medicare Number"/>-->
<!--            </div>-->

            <div class="form-group mb-3">
              <label for="sip_hasmedical">Medical Conditions</label>
              <select t-model="state.profile.sip_hasmedical" class="form-select" name="sip_hasmedical" aria-label="" required="1">
                <option>Please select</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            <div class="form-group mb-3" t-if="state.profile.sip_hasmedical == 'true'">
              <label for="new_medicalnotes">Medical Condition Notes</label>
                <p class="text-muted">
                    Please provide details of any medical conditions or medication required.
                    eg. sever asthma, type1 diabetes, epilepsy, anaphylaxis or other server allergy
                </p>
              <textarea style="min-height: 90px;" t-model="state.profile.new_medicalnotes" class="form-control" name="new_medicalnotes" placeholder="Medical Conditions" required="1"/>
            </div>

<!--            <div class="form-group mb-3">-->
<!--              <label for="sip_hasdisability">Disabilities</label>-->
<!--              <select t-model="state.profile.sip_hasdisability" class="form-select" name="sip_hasdisability" aria-label="" required="1">-->
<!--                <option>Please select</option>-->
<!--                <option value="true">Yes</option>-->
<!--                <option value="false">No</option>-->
<!--              </select>-->
<!--            </div>-->
<!--            <div class="form-group mb-3" t-if="state.profile.sip_hasdisability == 'true'">-->
<!--              <label for="new_disabliltynotes">Disability Details</label>-->
<!--              <textarea style="min-height: 90px;" t-model="state.profile.new_disabliltynotes" class="form-control" name="new_disabliltynotes" placeholder="Disability Details" required="1"/>-->
<!--            </div>-->

<!--            <div class="form-group mb-3">-->
<!--              <label for="new_doctorname">Doctor Name</label>-->
<!--              <input t-model="state.profile.new_doctorname" type="text" class="form-control" name="new_doctorname" placeholder="Doctor Name"/>-->
<!--            </div>-->

<!--            <div class="form-group mb-3">-->
<!--              <label for="new_doctorphone">Doctor Phone</label>-->
<!--              <input t-model="state.profile.new_doctorphone" type="text" class="form-control" name="new_doctorphone" placeholder="Doctor Phone"/>-->
<!--            </div>-->

        </div>
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/pages/student_portal/views/my_classes.xml": `<templates>
    <t t-name="wpc_portal.student_portal_my_classes">
        <div>
            <WPCPortalStudentClassList state="state" schoolId="state.profile._new_schoolname_value" />
        </div>
        <div class="p-4 rounded shadow-sm" style="background: #ff914d0d; border-left: 4px solid #FF914D;">
            <h5 class="mb-3">Declaration</h5>
            <ul class="mb-4">
                <li>Upon receipt I will read my Student Placement Record form and abide by all conditions.</li>
                <li>I will obtain all the signatures require and return the forms to my school at least 2 weeks prior to the Start Date.</li>
                <li>I understand failure to comply may lead to cancellation of placements and jeopardise completion of my courses.</li>
                <li>I will complete all safety Induction requirements before placement.</li>
            </ul>

            <div class="form-check wpc-checkbox">
                <input class="form-check-input" id="new_declaration" name="new_declaration" type="checkbox" t-model="state.profile.new_declaration"/>
                <label class="form-check-label" for="new_declaration">I agree</label>
            </div>
        </div>
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/pages/student_portal/views/my_placements.xml": `<templates>
    <t t-name="wpc_portal.student_portal_my_placements">
        <div>
            <WPCPortalStudentPlacementList state="state" />
        </div>
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/pages/student_portal/views/personal_details.xml": `<templates>
    <t t-name="wpc_portal.student_portal_personal_details">
        <div>
            <h4>Personal Details</h4>
            <div class="portal_seperator mt-0"/>
            <div class="form-group mb-3">
              <label for="new_studentfn">First name</label>
              <input required="required" t-model="state.profile.new_studentfn" type="firstname" class="form-control" name="new_studentfn" placeholder="First name"/>
            </div>
            <div class="form-group mb-1">
              <label for="new_studentln">Last name</label>
              <input required="required"  t-model="state.profile.new_studentln" type="lastname" class="form-control" name="new_studentln" placeholder="Last name"/>
            </div>
            <div class="form-group mb-1">
                <label for="new_studentemail">Student Email <span style="font-size: smaller;" class="text-muted">(If not you please sign out)</span></label>
              <input disabled="disabled"  t-model="state.profile.new_studentemail" type="lastname" class="form-control" name="new_studentemail" placeholder="Email"/>
            </div>
            <div class="form-group mb-1">
              <label for="new_studentphone1">Phone</label>
              <input t-model="state.profile.new_studentphone1" type="phone" class="form-control" name="new_studentphone1" placeholder="Phone"/>
            </div>
<!--            <div class="form-group mb-3">-->
<!--              <label for="new_birthdate">Birthday</label>-->
<!--              <input t-model="state.profile.new_birthdate" type="date" class="form-control" name="new_birthdate" placeholder="DD/MM/YYYY"/>-->
<!--            </div>-->
            <div class="form-group mb-3">
              <label for="sip_dob">DOB <sup>(1)</sup></label>
              <input t-model="state.profile.sip_dob" type="date" class="form-control" name="sip_dob" placeholder="DD/MM/YYYY"/>
            </div>


            <div class="form-group mb-3">
              <label for="new_suburb">Suburb <sup>(2)</sup></label>
              <input t-model="state.profile.new_suburb" type="text" class="form-control" name="new_suburb" placeholder="Suburb"/>
            </div>

            <div class="form-group mb-3">
              <label for="new_postcode">Postcode</label>
              <input t-model="state.profile.new_postcode" type="text" class="form-control" name="new_postcode" placeholder="Postcode"/>
            </div>

            <div class="form-group mb-3" style="font-size: x-small;">
                <p class="text-muted">(1) DOB is required to calculate your age at the time of placements.</p>
                <p class="text-muted">(2) We will attempt to secure placements within reasonable travel distances.</p>
            </div>
        </div>
    </t>
</templates>
`,
"C:/apps/wpc-portal/wpc_portal/static/src/pages/student_portal/views/school_details.xml": `<templates>
    <t t-name="wpc_portal.student_portal_school_details">
        <div>
            <h4>School Details</h4>
            <div class="portal_seperator mt-0"/>
            <div class="mb-3 form-group">
              <label for="school" class="col-sm-2 col-form-label">Select Your School*</label>
              <div >
                <IsTomSelect
                    name="'_new_schoolname_value'"
                    load="getSchoolListItems.bind(this)"
                    value="{id: state.profile._new_schoolname_value, name: state.profile['_new_schoolname_value@OData.Community.Display.V1.FormattedValue']}"
                    valueField="'id'"
                    labelField="'name'"
                    searchField="'name'"
                    settings="{maxItems: 1, placeholder: 'Search schools...', create: false}"
                    onChange="(o) => { state.profile._new_schoolname_value = o }"
                />
              </div>
            </div>
            <div class="mb-3 form-group">
              <label for="new_studentyrlevel" class="col-sm-2 col-form-label">Year Level*</label>
              <div>
                <select name="new_studentyrlevel" class="form-select" aria-label="Default select example" t-model="state.profile.new_studentyrlevel">
                  <option value="9">Year 9</option>
                  <option value="10">Year 10</option>
                  <option value="11">Year 11</option>
                  <option value="12">Year 12</option>
                  <option value="13">Tafe</option>
                </select>
              </div>
            </div>
        </div>
    </t>
</templates>
` };